import PropTypes from "prop-types"
import { People } from "@mui/icons-material"
import Header from "modules/home-header"

export default function TeamsHeader({ account }) {
  return <Header Icon={People} title="Teams" account={account} />
}

TeamsHeader.propTypes = {
  account: PropTypes.string,
}
